// @ts-ignore: No declarations available
import logdown from 'logdown';
import React from 'react';
import * as Icon from 'react-bootstrap-icons';
// @ts-ignore
import EllipsisText from 'react-ellipsis-text';
import { connect } from 'react-redux';
// @ts-ignore: No declarations available
import { returntypeof } from 'react-redux-typescript';
import { RouteProps, RouterProps } from 'react-router';
import { Button, Input, Label, ModalFooter, ModalHeader, ModalBody, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';

import { IconType } from '../../components/notification/Notification';
import { State } from '../../reducers';
import { showNotification } from '../notification';
import { DraggableModal } from '../utils';

import { closeMessageInformation } from './data/raw-notifications';

const logger = logdown('component:AlertSourceInformationModal');

class Component extends React.Component<Props, unknown> {
  inputRef: HTMLTextAreaElement | HTMLInputElement | null = null;

  componentDidMount() {
    this.updateInputHeight();
  }

  componentDidUpdate() {
    this.updateInputHeight();
  }

  updateInputHeight() {
    setTimeout(() => {
      if (this.inputRef) {
        this.inputRef.style.height = 'auto';
        this.inputRef.style.height = `${this.inputRef.scrollHeight}px`;
        this.inputRef.style.overflow = 'hidden';
      }
    }, 250);
  }

  copyToClipBoard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.props.showNotification(`Copied to clipboard`, IconType.SUCCESS);
      })
      .catch((error) => {
        console.error('Error copying text to clipboard:', error);
      });
  };

  public render() {
    logger.log(`RawNotification => ${this.props.messageInformationDialog.rawNotification.isSome()}`);

    return (
      <DraggableModal
        id="alert-source-information-modal"
        data-testid="alert-source-information-modal"
        size="lg"
        isOpen={this.props.messageInformationDialog.isOpen}
        // style={{ maxWidth: '1600px', width: '80%' }}
        toggle={this.close.bind(this)}
        onUnmountWhileOpen={this.close.bind(this)}
      >
        <ModalHeader data-testid="alert-source-information-modal-header" toggle={this.close.bind(this)}>
          <EllipsisText className="stakeholder-notifications-header" text={`Alert Source Information`} length={75} />
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Provider</Label>
          <InputGroup>
            <Input
              type="textarea"
              name="site"
              id="site"
              value={this.props.messageInformationDialog.rawNotification.map((a: any) => a.provider).getOrElse('N/A')}
              disabled={true}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText style={{ background: '#e3e3e3', cursor: 'pointer' }}>
                <Icon.Clipboard
                  onClick={() => {
                    this.copyToClipBoard(this.props.messageInformationDialog.rawNotification.map((a: any) => a.provider).getOrElse('N/A'));
                  }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
          <Label className="mr-sm-2">Message</Label>
          <InputGroup>
            <Input
              type="textarea"
              name="alert"
              id="alert"
              value={this.props.messageInformationDialog.rawNotification.map((a: any) => a.message).getOrElse('N/A')}
              disabled={true}
              style={{ maxHeight: 'unset' }}
              innerRef={(ref) => (this.inputRef = ref)}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText style={{ background: '#e3e3e3', cursor: 'pointer' }}>
                <Icon.Clipboard
                  onClick={() => {
                    this.copyToClipBoard(this.props.messageInformationDialog.rawNotification.map((a: any) => a.message).getOrElse('N/A'));
                  }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            className="stakeholder-notifications-cancel-button"
            data-testid="alert-source-information-modal-cancel-button"
            color="secondary"
            onClick={this.close.bind(this)}
          >
            Close
          </Button>
        </ModalFooter>
      </DraggableModal>
    );
  }

  protected close(e?: any) {
    e?.preventDefault();
    // if (this.props.stakeHolderNotificationSending.workLogs.isSome()) {
    //   return this.props.closeAlertStakeholderNotification();
    // }
    return this.props.closeMessageInformation();
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) =>
  bindActionCreators(
    {
      closeMessageInformation,
      showNotification,
    },
    dispatch,
  );

const mapStateToProps = (state: State) => ({
  user: state.user,
  messageInformationDialog: state.messageInformationDialog,
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps & RouteProps & RouterProps;

// @ts-ignore
export default connect<typeof stateProps, typeof dispatchProps, any>(mapStateToProps, mapDispatchToProps)(Component);
